var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLove1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7574 2.36517C12.1262 0.812905 9.47106 0.812905 7.83932 2.36482L7.50003 2.68709L7.16109 2.36497C5.52917 0.812847 2.87443 0.813022 1.24251 2.36497C0.44124 3.12709 0 4.13798 0 5.21113C0 6.28462 0.44124 7.29534 1.24263 8.05779L7.13771 13.6545C7.23911 13.751 7.36966 13.799 7.5 13.799C7.63034 13.799 7.76071 13.7508 7.86229 13.6543L13.7574 8.05779C14.5586 7.29551 15 6.28465 15 5.2113C15 4.13798 14.5586 3.12727 13.7574 2.36517ZM13.0321 7.29463L7.5 12.5469L1.96808 7.29481C1.37771 6.73342 1.05264 5.99341 1.05264 5.2113C1.05264 4.42919 1.37771 3.68918 1.96808 3.1278C2.58387 2.54183 3.39264 2.24904 4.20158 2.24904C5.0107 2.24904 5.81982 2.54218 6.43562 3.12815L7.13736 3.79465C7.34051 3.98781 7.65929 3.98781 7.86246 3.79465L8.56438 3.1278C9.79614 1.95604 11.8002 1.95604 13.0319 3.1278C13.6221 3.68921 13.9474 4.42919 13.9474 5.2113C13.9474 5.99341 13.6221 6.73325 13.0321 7.29463Z",
    fill: "#696969"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLove1);
export default __webpack_public_path__ + "static/media/love 1.8f8966adbfb65302bd4e210a88d9154d.svg";
export { ForwardRef as ReactComponent };